module.exports = __webpack_public_path__ + "static/photo27-8b747dfc129a641a5c647be8dbe79b2a.png";